import {
    Typography,
    Box,
    Stack,
} from "@mui/material";
import React from 'react';
import { useTranslation, Translation } from "react-i18next";
import { getLang } from "../helper/LangHelper";
import ReactApexChart from 'react-apexcharts';
import { useChart } from '../components/chart';
import theme from '../styles/theme';
import SimpleRadarChart from '../components/SimpleRadarChart';


function getDefaultSkills() {
    return [
        "vjump",
        "sitnreach",
        "situp",
        "balance",
    ]
}

function getCareerDataList() {
    return [
        {
            name: "VJump",
            value: 5,
            color: '#ff0',
        },
        {
            name: "SitnReach",
            value: 4,
            color: '#ff0',
        },
        {
            name: "SitUp",
            value: 3,
            color: '#ff0',
        },
        {
            name: "Balance",
            value: 2,
            color: '#ff0',
        },
    ]

}

export default function SkillRadarChart({ skillList, radarItems }) {
    const { t } = useTranslation();

    radarItems = radarItems || getDefaultSkills();

    console.debug("SkillRadarChart: skillList: ", skillList);
    console.debug("SkillRadarChart: radarItems: ", radarItems);

    // let radarItems = ['vjump', 'situp', 'sitnreach', 'flextest',
    //                 'ttest', 'handgrip', 'balance'];

    // let radarItems = ['vjump', 'curl_up', 'sitnreach', 'reaction',
    //     'yoyo', 'handgrip', 'balance'];
    let filteredList = skillList.filter((item) => {
        if(item.skill === null || item.skill === undefined){
            return false;
        }
        return radarItems.includes(item.skill.code);
    });

    let dataList = filteredList.map((skillInfo) => {

        return {

            name: skillInfo.skill.fitness_type_zh,
            value: skillInfo.rank,
            color: '#ff0',
        }
    });



    let lang = getLang();
    let chartData =
        [
            { name: 'Series 1', data: [1, 4, 5, 2, 3, 0] },
            // { name: 'Series 2', data: [20, 30, 40, 80, 20, 80] },
            // { name: 'Series 3', data: [44, 76, 78, 13, 43, 10] },
        ];

    const chartColors = [
        theme.palette.primary.main,
        theme.palette.info.main,
        theme.palette.warning.main,
        theme.palette.error.main,
        theme.palette.panelRed.main,
        theme.palette.info.main,
        theme.palette.warning.main,
        theme.palette.error.main,
        theme.palette.primary.main,
        theme.palette.info.main,
        theme.palette.warning.main,
        theme.palette.error.main,
    ];


    return (

        <SimpleRadarChart dataList={dataList} />        
    )
}
